<template>
    <div>
        <VueDateFilter default-filter="today" @dateFilterChange="dateFilterChange" />
        <div>
            <div v-if="!loading">

                <span style="font-size: 60px; display: flex; align-items: center; justify-content: center">
                    <span v-for="error in errorMessages" style="display: flex; flex-direction: column; color:red; font-size: 20px; width: 100%">
                        {{error}}
                    </span>
                    <span v-if="errorMessages.length === 0"> {{ count}}</span>
                </span>

            </div>
            <div v-else class="loader" id="loader-1"></div>

        </div>
    </div>

</template>

<script>
import VueDateFilter from "../../generic/VueDateFilter";
export default {

    components: {
        VueDateFilter
    },
    name: "VisitCounterWidget",

    data() {
        return {
            loading: false,
            count: 0,
            errorMessages: [],
        }
    },
    methods: {
        dateFilterChange(dateFromTimestamp, dateToTimestamp) {
            this.errorMessages = [];
            this.loading = true;
            this.count = 0;
            axios.post('traffic-log-insights/count', {
                start: dateFromTimestamp,
                end: dateToTimestamp
            }).then((res) => {
                this.loading = false;
                this.count = res.data.count;
            }).catch(({response, request}) => {
                if(response.data && response.data.errors) {
                    for (const property in response.data.errors) {
                        this.errorMessages.push(response.data.errors[property][0]);
                    }
                }
                this.loading = false;
            })
        }
    }
}
</script>

<style scoped>

.loader{
    width: 100px;
    height: 100px;
    border-radius: 100%;
    position: relative;
    margin: 0 auto;
}

#loader-1:before, #loader-1:after{
    content: "";
    position: absolute;
    top: -10px;
    left: -10px;
    width: 100%;
    height: 100%;
    border-radius: 100%;
    border: 10px solid transparent;
    border-top-color: #3498db;
}

#loader-1:before{
    z-index: 100;
    animation: spin 1s infinite;
}

#loader-1:after{
    border: 10px solid #ccc;
}


@keyframes spin{
    0%{
        -webkit-transform: rotate(0deg);
        -ms-transform: rotate(0deg);
        -o-transform: rotate(0deg);
        transform: rotate(0deg);
    }

    100%{
        -webkit-transform: rotate(360deg);
        -ms-transform: rotate(360deg);
        -o-transform: rotate(360deg);
        transform: rotate(360deg);
    }
}

</style>



// WEBPACK FOOTER //
// resources/js/admin-panel/components/widgets/VisitCounterWidget/VisitCounterWidget.vue